export var addSuffix = function addSuffix(val, suffix) {
  return typeof val !== 'undefined' && suffix ? "" + val + suffix : val;
};